import * as yup from "yup";

export default yup.object().shape({
  mypageName: yup.string().required("이름을 입력해 주세요."),
  userPhone2: yup.string().required("핸드폰 번호를 입력해 주세요."),
  verifiCode: yup.string().required("문자로 수신한 인증코드를 입력해 주세요."),
  Address3: yup.string().required("상세주소를 입력해 주세요."),
});
